import { changeContentSequenceIndex } from './changeContentSequenceIndex'
import { findNextUncompletedFlowItemIndexInActiveMission } from '../../user-progress/user-progress-use-cases/findNextUncompletedFlowItemIndexInActiveMission'

async function changeContentSequenceIndexToNextUncompletedObjective() {
  const nextUncompletedIndex = await findNextUncompletedFlowItemIndexInActiveMission()
  changeContentSequenceIndex(nextUncompletedIndex ?? 0)
}

export { changeContentSequenceIndexToNextUncompletedObjective }